import * as Sentry from '@sentry/react';
import getEnvVariable from './utils/env';
import history from './history';

const nodeEnv = getEnvVariable('NODE_ENV');
const reactSentryEnv = getEnvVariable('REACT_APP_SENTRY_ENV');
const reactSentryUrl = getEnvVariable('REACT_APP_SENTRY_URL');

if (nodeEnv === 'development') {
  // eslint-disable-next-line no-console
  console.log('Sentry not initialized in development mode');
} else if (
  reactSentryUrl === undefined ||
  reactSentryUrl === '' ||
  reactSentryEnv === undefined ||
  reactSentryEnv === ''
) {
  // eslint-disable-next-line no-console
  console.log('Sentry not initialized, REACT_APP_SENTRY_URL is undefined');
} else {
  Sentry.init({
    dsn: reactSentryUrl,
    environment: reactSentryEnv,
    integrations: [
      // Same as previously: console and errors
      Sentry.replayIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.httpClientIntegration(),
      // Profiling tab in sentry
      Sentry.reactRouterV4BrowserTracingIntegration({ history }),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      'api.wine-services.com',
      'api-staging.wine-services.com'
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

// Posthog deactivated for now
/* const reactAppPosthogApiKey = getEnvVariable('REACT_APP_POSTHOG_API_KEY');
const reactAppPosthogHost = getEnvVariable('REACT_APP_POSTHOG_HOST');

if (nodeEnv === 'development') {
  // eslint-disable-next-line no-console
  console.log('Posthog not initialized in development mode');
} else if (
  reactAppPosthogApiKey === undefined ||
  reactAppPosthogApiKey === '' ||
  reactAppPosthogHost === undefined ||
  reactAppPosthogHost === ''
) {
  // eslint-disable-next-line no-console
  console.log(
    'Posthog not initialized, REACT_APP_POSTHOG_API_KEY or REACT_APP_POSTHOG_HOST are undefined'
  );
} else {
  posthog.init(reactAppPosthogApiKey, {
    api_host: reactAppPosthogHost
  });
} */
